import React from 'react'
import { Row, Col, Button } from 'reactstrap'

const FlagActionButtons = ({
  onRemoveClick,
  onIgnoreClick,
  onViewCommentsClick,
  disabled,
  hasComments
}) => (
  <Row>
    <Col xs="12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {hasComments ? (
        <Button onClick={onViewCommentsClick}>View Comments</Button>
      ) : null}
      <Button color="primary" onClick={onIgnoreClick} disabled={disabled}>
        Ignore
      </Button>
      <Button color="danger" onClick={onRemoveClick} disabled={disabled}>
        Remove
      </Button>
    </Col>
  </Row>
)

export default FlagActionButtons



// WEBPACK FOOTER //
// ./src/views/Components/FlagActionButtons.js